import * as React from "react"
import { WorkItemPushFieldType } from "@digits-graphql/frontend/graphql-bearer"
import {
  FieldStatus,
  type WorkItemRowAction,
  type WorkItemRowState,
} from "src/frontend/components/OS/Applications/Boost/WorkItems/WorkItemRow/reducers/workItemReducer"

interface WorkItemRowContextProps {
  state: WorkItemRowState
  dispatch: React.Dispatch<WorkItemRowAction>
  rowRef: React.RefObject<HTMLElement | null>
}

const defaultFieldStatuses = new Map<WorkItemPushFieldType, FieldStatus>([
  [WorkItemPushFieldType.Category, FieldStatus.New],
  [WorkItemPushFieldType.Party, FieldStatus.New],
])

export const WorkItemRowContext = React.createContext<WorkItemRowContextProps>({
  state: {
    pushed: false,
    closed: false,
    reopened: false,
    fieldPushed: false,
    threadId: undefined,
    fieldStatuses: defaultFieldStatuses,
    highlightUpdated: false,
    originalValues: {
      category: undefined,
      party: undefined,
    },
  },
  dispatch: () => {},
  rowRef: React.createRef(),
})

export function useWorkItemRowContext() {
  return React.useContext(WorkItemRowContext)
}
